import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'
import { useLogEvent } from '~/hooks/useLogEvent'

import { useCloneDocumentReportMutation } from '../hooks/useCloneDocumentReportMutation'
import {
  type DocumentReport,
  useInvalidateDocumentReportsInfiniteQuery,
} from '../hooks/useDocumentReportsInfiniteQuery'

export type CloneButtonProps = {
  documentReport: DocumentReport
}

export const CloneButton = ({ documentReport }: CloneButtonProps) => {
  const { t } = useTranslation()
  const invalidateDocumentReportsInfiniteQuery =
    useInvalidateDocumentReportsInfiniteQuery()
  const logEvent = useLogEvent()
  const cloneDocumentReportMutation = useCloneDocumentReportMutation({
    onSuccess: () => {
      invalidateDocumentReportsInfiniteQuery()
      logEvent('Copy document')
    },
  })
  const handleClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    cloneDocumentReportMutation.mutate(documentReport.id)
  }, [cloneDocumentReportMutation, documentReport.id])

  return (
    <StyledButton
      disabled={cloneDocumentReportMutation.isPending}
      fillMode="outline"
      icon="copy"
      onClick={handleClick}
    >
      {t('duplicate')}
    </StyledButton>
  )
}
